import { firebaseDb } from "../../firebase";
import * as actionTypes from "./actionTypes";

export const getEventsStart = () => {
  return {
    type: actionTypes.GET_EVENTS_START,
  };
};

export const selectEvent = (selectedEvent) => {
  // localStorage.setItem("test", selectedEvent);
  return {
    type: actionTypes.SELECT_EVENT,
    selectedEvent: selectedEvent,
  };
};

export const getEventEntered = (eventEntered) => {
  return {
    type: actionTypes.EVENT_ENTERED,
    eventEntered: eventEntered,
  };
};

export const getEventEnteredCleared = (eventEntered) => {
  return {
    type: actionTypes.EVENT_ENTERED_CLEARED,
    eventEntered: eventEntered,
  };
};

export const getEventSuccess = (events) => {
  return {
    type: actionTypes.GET_EVENTS_SUCCESS,
    events: events,
  };
};

export const getEventsFail = (error) => {
  return {
    type: actionTypes.GET_EVENTS_FAIL,
    error: error,
  };
};

export const getEvents = () => {
  let events = [];
  return (dispatch) => {
    firebaseDb
      .collection("Event")
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach(function (doc) {
          let event = { id: doc.id, data: doc.data() };
          events.push(event);
        });
      })
      .then(() => {
        console.log("events", events);
        dispatch(getEventSuccess(events));
      });
  };
};

export const getUserEvents = (userId, eventId) => {
  let userActivities = [];
  return (dispatch) => {
    // dispatch(getActivitiesStart());
    console.log("userId", userId);
    // Add a new document in collection "cities"
    let user_event = firebaseDb
      .collection("User_Event")
      .where("userId", "==", userId);

    user_event
      .where("eventId", "==", eventId)
      .get()
      .then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          console.log("event entered already");
          dispatch(getEventEntered(true));
          // doc.data() is never undefined for query doc snapshots
          // console.log(doc.id, " => ", doc.data());
          // let userActivity = { id: doc.id, data: doc.data() };
          // userActivities.push(userActivity);
          // console.log("userActivity", userActivity);
          // console.log("userActivities", userActivities);
        });
      })
      .then(() => {
        // console.log("activities", userActivities);
        // dispatch(getActivitiesSuccess(userActivities));
      })
      .catch(function (error) {
        console.log("Error getting documents: ", error);
      });
  };
};
